/**
 * OrbDocCoreConceptsStandardLibraryARDocScreenView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait OrbDocCoreConceptsStandardLibraryARDocScreen
 */

import { useOrbDocCoreConceptsStandardLibraryARDocScreenLogic } from '@/hooks/traits/useOrbDocCoreConceptsStandardLibraryARDocScreenLogic';
import type { OrbDocCoreConceptsStandardLibraryARDocScreenConfig } from '@/hooks/traits/useOrbDocCoreConceptsStandardLibraryARDocScreenLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { OrbDocCoreConceptsStandardLibraryARDocView as OrbDocCoreConceptsStandardLibraryARDocViewEntity } from '@app/shared';
import { OrbDocCoreConceptsStandardLibraryARDocBodyView } from '@/components/traits/OrbDocCoreConceptsStandardLibraryARDocBodyView';
import { OrbDocCoreConceptsStandardLibraryARDocFooterView } from '@/components/traits/OrbDocCoreConceptsStandardLibraryARDocFooterView';
import { OrbDocCoreConceptsStandardLibraryARDocHeaderView } from '@/components/traits/OrbDocCoreConceptsStandardLibraryARDocHeaderView';
import { Stack } from '@almadar/ui/components';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';

interface OrbDocCoreConceptsStandardLibraryARDocScreenViewProps {
  config?: Partial<OrbDocCoreConceptsStandardLibraryARDocScreenConfig>;
}

export function OrbDocCoreConceptsStandardLibraryARDocScreenView({ config: propsConfig }: OrbDocCoreConceptsStandardLibraryARDocScreenViewProps) {
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useOrbDocCoreConceptsStandardLibraryARDocScreenLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['OrbDocCoreConceptsStandardLibraryARDocView'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="OrbDocCoreConceptsStandardLibraryAR" trait="OrbDocCoreConceptsStandardLibraryARDocScreen">
      <UISlotComponent slot="main" pattern={slotWriter['main'] === 'INIT' ? "stack" : "clear"} sourceTrait="OrbDocCoreConceptsStandardLibraryARDocScreen">{slotWriter['main'] === 'INIT' ? (<Stack direction="vertical" gap="none"><OrbDocCoreConceptsStandardLibraryARDocHeaderView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><OrbDocCoreConceptsStandardLibraryARDocBodyView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><OrbDocCoreConceptsStandardLibraryARDocFooterView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Stack>) : null}</UISlotComponent>
    </TraitScopeProvider>
  );
}

export default OrbDocCoreConceptsStandardLibraryARDocScreenView;
